import styled from "styled-components/macro";
import { focusVisible } from "../../../../styles/a11y";

export const StyledPrompt = styled.div`
  width: calc(99% - 1px);
  position: relative;
  margin-left: 1%;
  padding-right: 2px;

  label {
    font-family: "Inter";
    color: var(--grey-0);
  }

  textarea {
    ${({ isInSitu }) => (isInSitu ? `width: 95%;` : `width: 96%;`)}
  }
`;

export const StyledContext = styled.div`
  ${({ isInSitu }) => (isInSitu ? `width: 102%;` : `width: 49%;`)}
  float: left;
  position: relative;
  margin-left: 1%;

  textarea {
    width: 92%;
  }

  label {
    font-family: "Inter";
    color: var(--grey-1);
  }
`;

export const StyledExamples = styled.div`
  width: 49%;
  float: left;
  position: relative;
  margin-left: 1%;
  overflow-y: auto;
  height: auto;
  padding-bottom: 10px;
  textarea {
    width: 92%;
  }

  a {
    width: 20px;
    position: absolute;
    top: 3px;
    right: 6px;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }

  label {
    font-family: "Inter";
    color: var(--grey-1);
  }
`;

export const StyledExample = styled.div`
  position: relative;
  padding-left: 5px;
  padding-right: 2px;
`;

export const StyledStartersContainer = styled.div`
  max-height: 40vh;
  height: auto;
  overflow: auto;
  padding-top: 5px;

  ${StyledExample} {
    textarea {
      ${({ isInSitu }) => isInSitu && `width:90%;`}
    }

    a.delete {
      ${({ isInSitu }) => isInSitu && `right: 6px;`}
      path {
        fill: var(--icon-button-fill);
      }
    }
  }
`;

export const StyledAddAnother = styled.div`
  appearance: none;
  background: none;
  font: inherit;
  border: 1.5px solid var(--grey-0);
  color: var(--grey-0);
  border-radius: 30px;
  padding: 8px 12px 8px 12px;
  margin-top: 5px;
  font-size: 11px;
  letter-spacing: 0.15em;
  font-weight: bold;
  cursor: pointer;
  float: ${({ isInSitu }) => (isInSitu ? "right" : "left")};
  ${({ isInSitu }) => (isInSitu ? "" : "")}
  margin-left: 6px;
  text-transform: uppercase;
  ${({ isInSitu }) => isInSitu && "margin-right:2%;"};

  &:hover {
    background: var(--menu-color-hover);
  }

  ${focusVisible}
`;

export const StyledExamplesLabel = styled.label`
  padding-left: 5px;
`;

export const StyledContextLabel = styled.label`
  padding-bottom: 5px;
`;

export const StyledSubBrainform = styled.div`
  ${({ width }) => `width: ${width}`};

  textarea {
    border-radius: 5px;
    padding: 10px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    resize: none;
    background: var(--menu-color);
    color: var(--grey-0);
    border: 1.5px solid var(--grey-2);
    outline: 3px solid transparent;
    ::selection {
      background: var(--text-highlight);
    }

    &:focus {
      border: 1.5px solid transparent;
      outline: 3px solid var(--primary-cta-hover);
    }
  }
`;

export const StyledBottomSection = styled.div`
  margin-top: 15px;
  clear: both;
  display: inline-block;
  float: right;

  a {
    float: right;
    padding: 23px;
    color: var(--primary-cta);
  }

  button {
    float: right;
    background: var(--primary-cta) !important;
    font-weight: bold;
    font-size: 18px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 5px;
  }
`;

export const StyledRandomButton = styled.button`
  position: absolute;
  right: 10px;
  top: 35px;
  cursor: pointer;
  padding: 5px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  ${({ spin }) =>
    spin &&
    `svg {
      transition: all 300ms;
      transform: rotate(180deg);
    }`}

  svg {
    width: 15px;
    height: 15px;
    path {
      stroke: var(--icon-button-fill);
      transition: opacity 200ms;
    }
  }

  &:hover {
    svg {
      path {
        opacity: 1;
      }
    }
  }
`;
